import Dexie from 'dexie';
var initializeServiceWorkerDB = function () {
    //@ts-ignore
    if (typeof window.lturServiceWorker !== 'undefined' && window.lturServiceWorker.activate) {
        var postCacheTtl_1 = 300000;
        // @ts-ignore
        if (typeof window.lturServiceWorker !== 'undefined') {
            // @ts-ignore
            postCacheTtl_1 = window.lturServiceWorker.postCacheTtl;
        }
        var db_1 = new Dexie("post_cache");
        db_1.version(1).stores({
            post_cache: 'key,response,timestamp'
        });
        //@ts-ignore
        db_1.post_cache.where('timestamp').below(Date.now() - postCacheTtl_1).delete();
        setInterval(function () {
            //@ts-ignore
            db_1.post_cache.where('timestamp').below(Date.now() - postCacheTtl_1).delete();
        }, postCacheTtl_1);
    }
};
export default initializeServiceWorkerDB;
